import { useSelector } from "react-redux";
import MenuWidget from "../Widget/MenuWidget";
import SocialWidget from "../Widget/SocialWidget";

const menuDataOne = [
  {
    title: "Medical Conditions",
    href: "https://getafixmd.com/medical-conditions.html",
  },
  { title: "Healthcare Service", href: "/benefits#healthcare" },
  { title: "Complementary Services", href: "/benefits#complementary" },
  { title: "Value Added Services", href: "/benefits#valueAdded" },
  { title: "Nebula", href: "https://getafixmd.com/nebula.html" },
];

const menuDataTwo = [
  { title: "About Us", href: "https://getafixmd.com/about-us.html" },
  { title: "Contact Us", href: "https://getafixmd.com/contact-us.html" },
  {
    title: "Commonly Asked Questions",
    href: "https://getafixmd.com/commonly-faq.html",
  },
  {
    title: "Terms & Conditions",
    href: "https://getafixmd.com/terms-conditions.html",
  },
  { title: "Privacy Policy", href: "https://getafixmd.com/privacy-policy.html" },
];



export default function Footer() {

  const user = useSelector((state) => state.user.user);

  return (
    <>
      <footer
        className="cs_footer cs_style_1"
        style={{
          paddingTop: (user?.success && user?.user?.token) ? "32px" : "100px",
        }}
      >
        <div className="containerFooter" >
          {
            (user?.success && user?.user?.token) ?
              <></>
              :
              <>
                <div className="row" style={{ marginBottom: "48px" }}>
                  <div className="col-lg-3 col-md-6">
                    <img
                      src={"/images/getafixmd.png"}
                      alt=""
                      style={{ width: "148px", height: "auto", marginBottom: "16px" }}
                    />
                    <p
                      style={{
                        fontSize: "16px",
                        fontWeight: "400",
                        color: "#ffffff",
                        lineHeight: "1.5",
                        marginBottom: "24px",
                      }}
                    >
                      To get the latest updates, connect with <br /> us on our official social media channels.
                    </p>
                    <SocialWidget />
                  </div>
                  <div className="col-lg col-md-6 foot-padding1">
                    <h2 className="cst-footer-heading" style={{ color: "#0effbe" }}>
                      Service Links
                    </h2>
                    <MenuWidget data={menuDataOne} />
                  </div>
                  <div className="col-lg col-md-6">
                    <h2 className="cst-footer-heading" style={{ color: "#0effbe" }}>
                      Quick Links
                    </h2>
                    <MenuWidget data={menuDataTwo} />
                  </div>
                  <div className="col-lg col-md-6 contactusFooter">
                    <h2 className="cst-footer-heading" style={{ color: "#0effbe" }}>
                      Contact Us
                    </h2>
                    <div className="d-flex" style={{ paddingTop: "24px" }}>
                      <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 448 512">
                        <path fill="#0effbe"
                          d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7 .9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z" />
                      </svg>
                      <a href="https://api.whatsapp.com/send/?phone=%2B919995159567&text&type=phone_number&app_absent=0" target="_blank" rel="noreferrer" style={{ display: "flex", alignItems: "center" }}>
                        <div
                          style={{
                            fontSize: "16px",
                            lineHeight: "18px",
                            fontWeight: "600",
                            color: "#fff",
                            paddingLeft: "5px",
                          }}
                        >
                          +91 9995159567
                        </div>
                      </a>
                    </div>
                    <div className="d-flex" style={{ paddingTop: "24px" }}>
                      <img src="/images/mail-svgrepo-com.svg" alt="" />
                      <a
                        href="mailto:info@getafixmd.com"
                        style={{
                          fontSize: "16px",
                          lineHeight: "18px",
                          fontWeight: "600",
                          paddingLeft: "10px",
                          color: "#fff",
                        }}
                      >
                        info@getafixmd.com
                      </a>
                    </div>
                    <div class="btn-area1" style={{ paddingTop: "24px" }}>
                      <a href="https://pricing.getafixmd.com/" class="vl-btn8"><span class="text">Subscribe Now</span><span
                        class="arrow"><i class="fa-solid fa-arrow-right"></i></span></a>
                    </div>
                  </div>
                </div >
                <div>
                  <hr />
                </div>
              </>
          }
          <div
            style={{
              padding: "24px 0px 0px 0px",
              textAlign: "center",
              color: "#0effbe",
              fontSize: "16px",
              backgroundColor: "#0e6ebe",
            }}
          >
            {`Copyright ©${new Date().getFullYear()} GetAFixMD. All Rights Reserved`}
          </div>
        </div>
      </footer >
    </>
  );
}



